<!-- smeltingEquipment -->
<template>
  <div class="smeltingEquipment">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="opctBox">
          <div class="p1">悬浮冶金领域，赛迈特的技术达到了国际先进水平</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="bgBox section2 " id="设备简介">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="top">
            <div class="box1">
              <div class="topTitle leftTop">
                <div class="p1">
                  <span>设备</span>简介
                </div>
                <div class="p2"></div>
                <div class="p3">ABOUT EQUIPMENT</div>
                <div class="p4">
                  悬浮熔炼设备系统核心是冷坩埚感应悬浮熔炼技术,将分瓣的水冷坩埚置于交变电磁场内，利用电磁场产生的涡流热熔融金属，依靠电磁力使熔融金属与坩埚壁保持软接触或非接触状态从而实现炉料熔炼的技术；最大特点：被熔炉料呈悬浮或准悬浮状态，可解决现有材料生产工艺中缺陷（不均匀化+二次污染）
                </div>
                <div class="p5">
                  赛迈特已经开发完成的科研项目包括：在增强悬浮力，提高熔炼温度，延长坩埚寿命，扩大设备规格，提高运行效率，改善合金均匀性，实现数字化、智能化操作等方面的研究。与各种铸造技术相结合的研究，可实现的技术包括：底铸、倾铸吸铸、离心铸造、挤压铸造、连续拉锭等。与气雾化制粉，定向凝固、区熔提纯、快淬急冷等相结合的冷坩埚熔炼技术。
                </div>
              </div>
            </div>
            <div class="box2">
              <img src="../../static/images/smeltingEquipment/设备简介.jpg" alt="">
            </div>
          </div>
          <div class="bottom">
            <div class="item">均匀化</div>
            <div class="item">高纯度</div>
            <div class="item">熔炼温度高</div>
            <div class="item">规格范围大</div>
            <div class="item">悬浮能力强</div>
            <div class="item">浇铸凝壳少</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3 " id="设备组成">
      <div class="s3_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>设备</span>组成
          </div>
          <div class="p2"></div>
          <div class="p3">EQUIPMENT PARTS</div>
        </div>
        <div class="bodyBox">
          <div class="item">
            <div class="p1">设备主机系统</div>
            <div class="p2">Furnace</div>
          </div>
          <div class="item">
            <div class="p1">电源系统</div>
            <div class="p2">Power supply system</div>
          </div>
          <div class="item">
            <div class="p1">辅助操作系统</div>
            <div class="p2">Intelligent operating system</div>
          </div>
          <div class="item">
            <div class="p1">控制系统</div>
            <div class="p2">Automatic control system</div>
          </div>
          <div class="item">
            <div class="p1">冷却系统</div>
            <div class="p2">Water cooling system</div>
          </div>
          <div class="item">
            <div class="p1">真空系统</div>
            <div class="p2">Vacuum system</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4 " id="领先技术">
      <div class="s4_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>领先</span>技术
          </div>
          <div class="p2"></div>
          <div class="p3">LEADING TECHNOLOGY</div>
        </div>
        <div class="box1">
          <div class="item">
            <img src="../../static/images/smeltingEquipment/悬浮能力强.png" alt="">
            <div class="p1">
              悬浮能力强
            </div>
            <div class="p2"></div>
            <div class="p3">熔池驼峰的高/径比=2.0~3.0,在熔炼过程中凝壳很少</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/熔炼温度高.png" alt="">
            <div class="p1">
              熔炼温度高
            </div>
            <div class="p2"></div>
            <div class="p3">最高熔炼温度可达3600℃，能熔炼包括钨、钽、钼、铌等各种难熔金属</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/规格范围广.png" alt="">
            <div class="p1">
              规格范围广
            </div>
            <div class="p2"></div>
            <div class="p3">熔炼量从50g~200kg的规格系列</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/数字化.png" alt="">
            <div class="p1">
              数字化屏显
            </div>
            <div class="p2"></div>
            <div class="p3">设备各个系统的各项参数都会实时显示在屏幕，方便操作员查看</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/智能化.png" alt="">
            <div class="p1">
              智能化操作
            </div>
            <div class="p2"></div>
            <div class="p3">设备一键启停，各系统可关联控制操作员可快速智能操作</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/现代化技术.png" alt="">
            <div class="p1">
              结合多种现代技术
            </div>
            <div class="p2"></div>
            <div class="p3">离心铸、底铸、吸铸、连续拉锭、电弧熔炼、等离子熔炼等</div>
          </div>
        </div>
        <div class="box2">
          <div class="label">技术持续升级（可熔炼元素周期表绝大多数金属）</div>
          <img src="../../static/images/smeltingEquipment/折线图.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="bgBox section5" id="设备应用">
      <div class="s5_innerBox typeArea">
        <div class="topTitle leftTop">
          <div class="p1">
            <span>设备</span>应用
          </div>
          <div class="p2"></div>
          <div class="p3">EQUIPMENT APPLICATION</div>
          <div class="img">

          </div>
          <!-- <img src="../../static/images/smeltingEquipment/设备应用.jpg" alt=""> -->
        </div>
        <div class="carBox">
          <el-carousel indicator-position="outside" :interval="3000">
            <el-carousel-item :key="1" class="key1">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/通用型设备.jpg" alt="">
                <div class="fixBox">设备用于熔炼特种合金</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    高温合金，形状记忆合金，低熔点金属和合金
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/高温1.jpg" alt="">
                    </div>
                    <div class="item"><img src="../../static/images/smeltingEquipment/高温2.jpg" alt=""></div>
                  </div>
                </div>
                <div class="bottomBox">
                  <div class="p1">
                    高熵合金、块体非晶合金
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/高3.jpg" alt="">
                    </div>
                    <div class="item"><img src="../../static/images/smeltingEquipment/高4.jpg" alt=""></div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="2" class="key2">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/专用型.jpg" alt="">
                <div class="fixBox">设备用于提炼贵金属</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    从尾矿中提炼高附加值稀有贵金属
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/1.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/2.jpg" alt="">
                    </div>
                  </div>
                </div>
                <div class="bottomBox">
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/3.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/4.jpg" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="3" class="key3">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/悬浮型.jpg" alt="">
                <div class="fixBox">设备用于熔炼溅射靶材（真空镀膜材料）</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    半导体高纯溅射靶材、航天用合金溅射靶材
                  </div>
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮1.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮2.jpg" alt="">
                    </div>
                  </div>
                </div>
                <div class="bottomBox">
                  <div class="p2">
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮3.jpg" alt="">
                    </div>
                    <div class="item">
                      <img src="../../static/images/smeltingEquipment/悬浮4.jpg" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4" class="key4">
              <div class="left">
                <img src="../../static/images/smeltingEquipment/MINI型.jpg" alt="">
                <div class="fixBox">设备用于高校科研院所的实验室仪器</div>
              </div>
              <div class="right">
                <div class="topBox">
                  <div class="p1">
                    高校、科研院所的基础材料试验装置
                  </div>
                  <div class="p3">
                    <div class="left">
                      <img src="../../static/images/smeltingEquipment/型1.jpg" alt="">
                    </div>
                    <div class="right">
                      <div class="item">
                        <img src="../../static/images/smeltingEquipment/型2.jpg" alt="">
                      </div>
                      <div class="item">
                        <img src="../../static/images/smeltingEquipment/型3.jpg" alt="">
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="bgBox section6" id="设备规格">
      <div class="s6_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>设备</span>规格
          </div>
          <div class="p2"></div>
          <div class="p3">EQUIPMENT SPECIFICATION</div>
          <div class="p4">
            用户可根据要求定制特殊规格,真空度、控制模式等可根据用户要求设计， 铸造方式默认倾铸，可配备底铸、离心铸、连续拉锭、加料器等附加装置
          </div>
        </div>
        <div class="tableBox">
          <table width="100%" height="100%">
            <tbody>
              <tr>
                <th width="86px" class="redtd">类型</th>
                <th width="223px">型号</th>
                <th width="240px">熔炼量Fe/Ti（kg）</th>
                <th width="240px">极限真空度（Pa）</th>
                <th width="196px">熔炼温度（℃）</th>
                <th>控制模式</th>
              </tr>
              <tr>
                <td rowspan="2" class="redtd">微型</td>
                <td>SMTX-XF-0.05</td>
                <td>0.05/0.03</td>
                <td rowspan="15">
                  <div class="div">可根据用户实际要求定制：</div>
                  <div>*** × 10<sup>-2</sup></div>
                  <div>*** × 10<sup>-3</sup></div>
                  <div>*** × 10<sup>-4</sup></div>
                </td>
                <td rowspan="15">≤3400℃</td>
                <td rowspan="15">
                  <div>PLC+触控屏 或</div>
                  <div>PLC+工控机</div>
                  <div>可实现程序控制</div>
                  <div>有水温、水压、</div>
                  <div>气体超压和停电</div>
                  <div>保护</div>
                </td>
              </tr>
              <tr>
                <td>SMTX-XF-0.1</td>
                <td>0.1/0.06</td>
              </tr>
              <tr>
                <td rowspan="5" class="redtd">小型</td>
                <td>SMTX-XF-0.3</td>
                <td>0.3/0.16</td>
              </tr>
              <tr>
                <td>SMTX-XF-0.5</td>
                <td>0.5/0.3</td>
              </tr>
              <tr>
                <td>SMTX-XF-1</td>
                <td>1.0/0.6</td>
              </tr>
              <tr>
                <td>SMTX-XF-2</td>
                <td>2.0/1.2</td>
              </tr>
              <tr>
                <td>SMTX-XF-3</td>
                <td>3.0/1.8</td>
              </tr>
              <tr>
                <td rowspan="3" class="redtd">中型</td>
                <td>SMTX-XF-5</td>
                <td>5.0/3.0</td>
              </tr>
              <tr>
                <td>SMTX-XF-6</td>
                <td>6.0/3.6</td>
              </tr>
              <tr>
                <td>SMTX-XF-10</td>
                <td>10/6.0</td>
              </tr>
              <tr>
                <td rowspan="5" class="redtd">大型</td>
                <td>SMTX-XF-20</td>
                <td>20/12</td>
              </tr>
              <tr>
                <td>SMTX-XF-25</td>
                <td>25/15</td>
              </tr>
              <tr>
                <td>SMTX-XF-50</td>
                <td>50/30</td>
              </tr>
              <tr>
                <td>SMTX-XF-100</td>
                <td>100/60</td>
              </tr>
              <tr>
                <td>SMTX-XF-200</td>
                <td>200/120</td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>
    </div>
    <div class="bgBox section7" id="客户案例">
      <div class="s7_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>客户</span>案例
          </div>
          <div class="p2"></div>
          <div class="p3">CLIENT CASES</div>
        </div>
        <div class="itemBox">
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例1.jpg" alt="">
            <div class="label">100kg氧化物装在包头某研究院</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例2.jpg" alt="">
            <div class="label">100kg悬浮炉(双炉)装在成都某高科技企业</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例3.jpg" alt="">
            <div class="label">50kg悬浮炉装在北京某金属研究总院</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例4.jpg" alt="">
            <div class="label">50kg悬浮炉装在石嘴山某高科技企业</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例5.jpg" alt="">
            <div class="label">50kg悬浮炉装在清远某高科技企业</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例7.jpg" alt="">
            <div class="label">50kg悬浮炉装在山东某企业</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例8.jpg" alt="">
            <div class="label">30kg悬浮炉装在沈阳某企业</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例9.jpg" alt="">
            <div class="label">30kg悬浮炉装在西安某金属研究院</div>
          </div>
          <div class="item">
            <img src="../../static/images/smeltingEquipment/案例6.jpg" alt="">
            <div class="label">20kg悬浮炉装在国防某研究院</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'smeltingEquipment',
    components: {},
    data() {
      return {

      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
      
    },
    mounted() {
      if(this.$store.state.pageId){
        this.$el.querySelector(this.$store.state.pageId).scrollIntoView({
          behavior:'smooth',
          block: "start"
        })
      }else{
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      this.$store.commit('savePageId','')
    },
    methods: {
      init() {

      },
    },
  }

</script>

<style lang='less' scoped>
  .smeltingEquipment {
    width: 100%;
    min-width: 1200px;


    .section1 {
      width: 100%;
      height: 600px;
      background: url('../../static/images/smeltingEquipment/banner.jpg') no-repeat;
      background-position: center;

      .s1_innerBox {
        padding-top: 234px;
        text-align: left;

        .opctBox {
          width: 1245px;
          height: 230px;
          // opacity: 0.4;
          background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 2%, rgba(0, 0, 0, 0.4) 20%, rgba(0, 0, 0, 0.4) 80%, rgba(255, 255, 255, 0.1) 98%, rgba(255, 255, 255, 0) 100%);

          .p1 {
            font-size: 48px;
            line-height: 48px;
            padding-top: 50px;
            color: #fefefe;
          }

          .line {
            width: 200px;
            height: 8px;
            margin-top: 85px;
            background-color: #c30000;
          }
        }

      }
    }

    .section2 {
      width: 100%;
      height: 762px;

      .s2_innerBox {
        height: 100%;
        padding-top: 218px;
        width:1288px;
        .bodyBox {
          width: 100%;
          height: 544px;
          padding: 0 35px 20px 35px;
          background-color: #ffffff;
          border: solid 2px #f2f2f2;

          .top {
            display: flex;
            height: 460px;

            .box1 {
              flex: 1;

              .topTitle {
                .p1 {
                  margin-top: 35px;
                }

                .p3 {
                  margin-bottom: 45px;
                }

                .p4,
                .p5 {
                  font-size: 16px;
                  line-height: 28px;
                  color: #545454;
                  text-indent: 2em;
                  padding-right: 10px;
                  font-weight: 400;
                }
              }
            }

            .box2 {
              width: 622px;
              height: 100%;
              position: relative;

              img {
                position: absolute;
                top: -53px;
                right: 0;
              }
            }
          }

          .bottom {
            display: flex;
            justify-content: space-between;

            .item {
              width: 163px;
              height: 44px;
              line-height: 40px;
              text-align: center;
              border: solid 2px #c30000;
              font-size: 24px;
              color: #c30000;
            }
          }
        }
      }
    }

    .section3 {
      width: 100%;
      height: 568px;

      .s3_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 178px;
          }
        }

        .bodyBox {
          margin-top: 50px;
          width: 100%;
          height: 420px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .item {
            width: 394px;
            height: 200px;
            background-color: #f2f2f2;
            display: flex;
            flex-direction: column;
            align-items: center;

            .p1 {
              width: 180px;
              height: 48px;
              line-height: 48px;
              background-color: #c30000;
              font-size: 24px;
              color: #fefefe;
              margin-top: 56px;
            }

            .p2 {
              font-size: 16px;
              line-height: 16px;
              color: #555555;
              font-weight: 400;
              margin-top: 22px;
            }
          }
        }
      }
    }

    .section4 {
      width: 100%;
      height: 1969px;
      margin-top: 176px;
      background-color: #fbfbfb;

      .s4_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 176px;
          }
        }

        .box1 {
          width: 100%;
          height: 676px;
          margin-top: 99px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .item {
            width: 320px;
            height: 338px;
            padding: 0 25px;
            display: flex;
            flex-direction: column;
            align-items: center;

            img {}

            .p1 {
              font-size: 18px;
              line-height: 18px;
              color: #333333;
              font-weight: 700;
              margin-top: 45px;

              span {
                color: #c30000;
              }
            }

            .p2 {
              width: 50px;
              height: 4px;
              background-color: #c30000;
              margin: 20px 0 10px 0;
            }

            .p3 {
              color: #545454;
              font-size: 16px;
              line-height: 30px;
            }
          }
        }

        .box2 {
          display: flex;
          flex-direction: column;
          align-items: center;

          .label {
            height: 44px;
            line-height: 44px;
            background-color: #c30000;
            padding: 0 18px;
            font-size: 20px;
            color: #ffffff;
            margin-top: 120px;
            margin-bottom: 55px;
          }
        }
      }
    }

    .section5 {
      width: 100%;
      height: 1149px;
      background-color: #fbfbfb;

      .s5_innerBox {
        position: relative;
        height: 100%;
        padding-top: 226px;
        .topTitle {
          margin-bottom: 183px;
          position: relative;
          .p1 {
            margin-top: 0;
          }

          .img {
            position: absolute;
            top: -64px;
            left: 500px;
            height: 200px;
            width: calc(~"100vw/2 + 90px");
            background: url('../../static/images/smeltingEquipment/设备应用.jpg') no-repeat;
            background-position: left;
          }
        }

        .carBox {
          /deep/ .el-carousel {
            .el-carousel__container {
              height: 425px;

              .el-carousel__arrow {
                display: none;
              }

              .el-carousel__item {
                display: flex;
                justify-content: space-between;

                .left {
                  width: 578px;
                  height: 100%;
                  position: relative;

                  img {
                    height: 100%;
                  }

                  .fixBox {
                    height: 40px;
                    width: 100%;
                    background-color: #c30000;
                    line-height: 40px;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 400;
                    color: #ffffff;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }

                .right {
                  width: 600px;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;

                  .p1 {
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 18px;
                    color: #ffffff;
                    background-color: #c30000;
                    width: 100%;
                    font-weight: 400;
                    margin-bottom: 7px;
                  }

                  .topBox,
                  .bottomBox {
                    height: 202px;
                    width: 100%;

                    .p2 {
                      display: flex;
                      height: 155px;
                      width: 100%;
                      justify-content: space-between;

                      .item {
                        height: 100%;
                        width: 284px;
                      }
                    }
                  }

                  .bottomBox {
                    height: 198px;

                    .p2 {
                      height: 151px;
                    }
                  }

                }
              }

              .key2,
              .key3 {
                .topBox {
                  height: 225px !important;
                }

                .bottomBox {
                  height: 178px !important;
                }

                .item {
                  height: 178px !important;
                }
              }

              .key4 {
                .topBox {
                  height: 100% !important;
                }

                .p3 {
                  height: 378px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;

                  .left {
                    height: 100%;
                    width: 284px;
                  }

                  .right {
                    width: 284px;
                    height: 100%;

                    .item {
                      height: 178px;
                    }
                  }
                }
              }
            }

            .el-carousel__indicators {
              margin-top: 20px;

              .el-carousel__button {
                width: 30px;
                height: 6px;
                background-color: #cccccc;
              }

              .is-active {
                .el-carousel__button {
                  width: 50px;
                  height: 6px;
                  background-color: #c30000;
                }
              }
            }
          }
        }
      }
    }

    .section6 {
      padding-top: 107px;
      width: 100%;
      height: 1210px;

      .s6_innerBox {
        position: relative;
        height: 100%;

        .topTitle {
          // margin-bottom: 183px;

          .p1 {
            margin-top: 0;
          }

          .p4 {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
            margin-top: 50px;
          }
        }

        .tableBox {
          width: 100%;
          height: 860px;
          margin-top: 60px;
          font-weight: 400;

          table {
            border-collapse: collapse;
          }

          .redtd {
            background-color: #c30000;
            color: #fefefe;
            font-size: 30px;

          }

          th.redtd {
            font-size: 16px;
          }

          tr {
            border: 1px solid #cccccc;
          }

          td,
          th {
            border: 1px solid #cccccc;
            font-size: 16px;
          }

          th {
            font-weight: normal;
            color: #333333;
            height: 44px;
          }

          td {
            font-weight: 400;
            color: #545454;
          }
        }
      }
    }

    .section7 {
      padding-top: 260px;
      width: 100%;
      // height: 1600px;
      padding-bottom: 60px;

      .s7_innerBox {
        position: relative;
        height: 100%;

        .topTitle {
          // margin-bottom: 183px;

          .p1 {
            margin-top: 0;
          }


        }

        .itemBox {
          margin-top: 48px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          // height: 1072px;
          width: 100%;

          .item {
            width: 393px;
            height: 507px;
              margin-bottom: 60px;
            position: relative;

            img {
              width: 100%;
              height: 447px;
            }

            .label {
              height: 60px;
              line-height: 60px;
              text-align: center;
              width: 100%;
              background-color: #f8f8f8;
              position: absolute;
              left: 0;
              bottom: 0;
              font-size: 16px;
              color: #545454;
              font-weight: 400;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/smeltingEquipment.vue